import React, { useState, useEffect } from 'react';
import { Mail } from 'lucide-react';
import { portfolioData } from '../data/portfolio';

const Hero = () => {
  const { profile } = portfolioData;
  const [displayedText, setDisplayedText] = useState('');
  const [isTypingComplete, setIsTypingComplete] = useState(false);

  useEffect(() => {
    const fullName = profile.name;
    let currentIndex = 0;
    const typingInterval = setInterval(() => {
      if (currentIndex <= fullName.length) {
        setDisplayedText(fullName.slice(0, currentIndex));
        currentIndex++;
      } else {
        setIsTypingComplete(true);
        clearInterval(typingInterval);
      }
    }, 100);

    return () => clearInterval(typingInterval);
  }, [profile.name]);

  return (
    <section className="min-h-screen flex items-center justify-center px-6 pt-20">
      <div className="max-w-6xl mx-auto w-full">
        <div className="flex flex-col md:flex-row items-center gap-8">
          {/* Left Side - Image (35% width) */}
          <div className="w-full md:w-[35%] flex justify-center md:justify-start">
            <div className="w-72 h-80 bg-[#151515] border border-white/10 rounded-2xl overflow-hidden">
              <img 
              src="/images/Tee.jpg"
              alt="Triumph Ogeh"
              className="w-full h-full object-cover object-top rounded-2xl"
              />
            </div>
          </div>

          {/* Right Side - Text Content (65% width) */}
          <div className="w-full md:w-[65%]">
            <h1 className="text-5xl md:text-6xl font-bold mb-6 leading-tight min-h-[80px]">
              {displayedText}
              {!isTypingComplete && <span className="animate-pulse text-[#00b4d8]">|</span>}
            </h1>
            
            {/* <p className="text-xl md:text-2xl text-[#00b4d8] font-medium mb-6">
              {profile.title}
            </p> */}
            
            <p className="text-lg text-[#a0a0a0] mb-8 leading-relaxed">
              {profile.tagline}
            </p>
            
            <div className="flex flex-col sm:flex-row gap-4">
              <a
                href={`mailto:${profile.email}`}
                className="group bg-[#00b4d8] text-white px-8 py-4 rounded-lg font-semibold hover:bg-[#0096c7] transition-all duration-300 flex items-center gap-2 justify-center sm:justify-start sm:w-auto"
              >
                Get In Touch
                <Mail size={20} className="group-hover:translate-x-0.5 transition-transform" />
              </a>
            </div>
          </div>
        </div>

        {/* Scroll Indicator */}
        <div className="mt-20 animate-bounce text-center">
          <div className="w-6 h-10 border-2 border-[#666666] rounded-full mx-auto flex items-start justify-center p-2">
            <div className="w-1.5 h-3 bg-[#00b4d8] rounded-full"></div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
